import { isAxiosError } from 'axios'

/** Must match `BOM_IMPORT_UNSUPPORTED_FILE_TYPE_ERROR_CODE` on the server. */
export const BOM_IMPORT_UNSUPPORTED_FILE_TYPE_ERROR_CODE =
  'BOM_IMPORT_UNSUPPORTED_FILE_TYPE'

/** Legacy English message from the API; map to localized copy on the client. */
export const BOM_IMPORT_UNSUPPORTED_FILE_TYPE_MESSAGE =
  'Unsupported file type. Upload an Excel .xlsx or .xls workbook.'

function readApiErrorPayload(error: unknown): {
  message?: string
  errorCode?: string
} {
  if (!isAxiosError(error)) {
    return {}
  }

  const data = error.response?.data
  if (data == null || typeof data !== 'object') {
    return {}
  }

  const record = data as { message?: unknown; errorCode?: unknown }
  const message =
    typeof record.message === 'string' && record.message.trim().length > 0
      ? record.message
      : undefined
  const errorCode =
    typeof record.errorCode === 'string' && record.errorCode.trim().length > 0
      ? record.errorCode
      : undefined

  return { message, errorCode }
}

export function isBomImportUnsupportedFileTypeApiError(error: unknown): boolean {
  const { message, errorCode } = readApiErrorPayload(error)
  if (errorCode === BOM_IMPORT_UNSUPPORTED_FILE_TYPE_ERROR_CODE) {
    return true
  }
  return message === BOM_IMPORT_UNSUPPORTED_FILE_TYPE_MESSAGE
}

export function resolveBomImportUploadErrorMessage(
  error: unknown,
  unsupportedFileTypeLabel: string,
  genericFailureLabel: string
): string {
  if (isBomImportUnsupportedFileTypeApiError(error)) {
    return unsupportedFileTypeLabel
  }
  return genericFailureLabel
}
